var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHybrid = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.12 8.693a.441.441 0 0 1 .336.055l.001-.001 1.525.893 1.524-.893.006-.004a.441.441 0 0 1 .441.764l-.005.001-1.525.896v1.633a.441.441 0 0 1-.882 0v-1.633l-1.526-.896a.44.44 0 0 1-.171-.607l.052-.072a.441.441 0 0 1 .224-.136Z",
    stroke: "#fff",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.747 1.914a.441.441 0 0 1 .459 0l2.18 1.317.462.28-.28-.001a.438.438 0 0 1-.42.539v.075l-.227-.138-1.94-1.18-1.939 1.18a.441.441 0 0 1-.458-.754l2.163-1.318Z",
    stroke: "#fff",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.982 14.504c.243 0 .44.198.44.441v1.979l1.5-.91.035-.022h.018a.44.44 0 0 1 .412.776l-2.17 1.317a.44.44 0 0 1-.404.028l-.055-.027-2.174-1.318a.441.441 0 0 1 .458-.754l1.499.909v-1.978c0-.243.197-.441.44-.441Z",
    stroke: "#fff",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.657 4.491a.44.44 0 0 1 .225.14l.052.075.035.083a.441.441 0 0 1-.227.523h.001l-1.539.843 1.716.99.075.044v.02a.44.44 0 0 1-.006.655l.125.073h-.237a.439.439 0 0 1-.177.039.442.442 0 0 1-.169-.035l-.052-.025-.485-.28h.001l-1.254-.724-.01 1.78a.441.441 0 1 1-.881-.002l.02-2.547c0-.158.084-.303.22-.382l.004-.001L4.319 4.54v.001a.44.44 0 0 1 .338-.05Z",
    stroke: "#fff",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.291 10.868a.441.441 0 0 1 .44.44l.013 2.284 1.998 1.095v.003a.44.44 0 0 1 .218.254l.02.09c.006.059 0 .119-.017.176l-.035.083a.442.442 0 0 1-.277.215.44.44 0 0 1-.116.012v.06l-.222-.122-2.225-1.219h-.003a.442.442 0 0 1-.22-.384L1.85 11.31c0-.244.198-.442.441-.442Z",
    stroke: "#fff",
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.987 3.247a3.848 3.848 0 0 0-3.844 3.844c0 2.883 3.844 7.139 3.844 7.139s3.844-4.256 3.844-7.14a3.848 3.848 0 0 0-3.844-3.843Zm0 1.098a1.098 1.098 0 1 1 0 2.197 1.098 1.098 0 0 1 0-2.197Zm0 5.492a2.626 2.626 0 0 1-2.197-1.181c.011-.725 1.466-1.126 2.197-1.126.73 0 2.185.401 2.196 1.126a2.627 2.627 0 0 1-2.196 1.18Z"
  })));
};
export { SvgHybrid as ReactComponent };